module.exports = __webpack_public_path__ + "static/img/m_sidebar_download@3x.4494821.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_sidebar_download@3x.png
// module id = YBtL
// module chunks = 1